import { ComponentPropsWithRef } from 'react';
import classNames from 'classnames';
import styles from './InteractiveArea.module.scss';

type InteractiveAreaProps = Omit<ComponentPropsWithRef<'button'>, 'type'>;

export default function InteractiveArea({
  className,
  ...rest
}: InteractiveAreaProps) {
  return (
    <button
      type="button"
      className={classNames(styles.container, className)}
      {...rest}
    />
  );
}
